module.exports = __webpack_public_path__ + "static/media/alert.2e5236ee.png";